const ApiURL = 'https://admin.streetartshire.com';
const DevApiURL = 'http://3.11.221.128';
export default ApiURL;